module.exports = __webpack_public_path__ + "static/media/add.5d97b571.svg";